<script>
import LearningMaterials from '@/views/ExtendableBases/LearningMaterials'

export default {
  extends: LearningMaterials
}
</script>
